import { Synthesizer } from "./synthesizer";
import {
  ToolCallEntry,
  toolCallEntryFromMessage,
} from "@agentic_system/components/tool-call-entry";
import { InterruptedFooter } from "./interrupted-footer";
import type { MessageThread } from "@agentic_conversation/pages/chat/types";
import { cn, formatDate } from "@ui";

interface UserThreadProps {
  thread: MessageThread;
}

export function UserThread({ thread }: UserThreadProps) {
  const { user, synthesizer, tools } = thread;
  const isInterrupted = synthesizer?.status === "interrupted";

  return (
    <div className="flex flex-col space-y-6">
      {/* User question */}
      <div className="w-3/5 bg-default-50 p-4 rounded-lg ring-1 ring-default-200 shadow-lg shadow-default flex flex-col space-y-4">
        <div className="flex flex-col space-y-2">
          <div className="text-xs font-medium uppercase text-default-500">
            Vous
          </div>
          <div className="text-default-600 font-medium">{user.content}</div>
        </div>
        <div className="text-[11px] text-slate-400">
          {formatDate(user.created_at)} (#{user.id})
        </div>
      </div>

      {/* AI response */}
      <div className="flex">
        <div
          className={cn(
            "bg-white",
            "ring-1",
            "ring-slate-300",
            "w-full",
            "rounded-lg",
            "text-slate-600",
            "overflow-hidden",
            "flex",
            "flex-col",
            "space-y-6",
            "p-6",
            "min-w-0",
          )}
        >
          {/* Chain of thought - Tools first */}
          {tools.length > 0 && (
            <div className="w-full min-w-0">
              {tools.map((tool, index) => (
                <ToolCallEntry
                  key={tool.id}
                  entry={toolCallEntryFromMessage(tool)}
                  isLast={index === tools.length - 1}
                />
              ))}
            </div>
          )}

          {/* Synthesizer response */}
          {synthesizer && !isInterrupted && <Synthesizer message={synthesizer} />}

          {/* Interrupted state - shown at card level */}
          {isInterrupted && <InterruptedFooter />}
        </div>
      </div>
    </div>
  );
}
